<template>
	<div>
		<div class="good-item-bigBox">
			<div class="good-item-box crumb-look-and-see-dom" :style="style">
				<div class="good-item" v-for="(item,index) in data" :key="index" @click="toDetail(item.unique)">
					<a class="pat-pro" >
						<img class="img-list" width="140" height="140" :src="item.image">
						<p class="money">
							<span class="ranking">{{index+1}}</span>
							<span class="selling">热销{{item.sales}}件</span>
							<span class="money-img">￥{{ item.price }}</span>
						</p>
						<p class="pro-infor">{{ item.skuName }}</p>
						<p class="pro-label"></p>
					</a>
				</div>
			</div>
		</div>
		<div class="bottom-arrow">
			<a href="" @click.prevent="prev" class="arrow-down arrow" :class="{disabled:index==1}"></a>
			<a href="" @click.prevent="next" class="arrow-up arrow"  :class="{disabled:index==pageLen}"></a>
			<!-- {{index}}/{{pageLen}} -->
		</div>
	</div>
</template>

<script>
import { Main } from 'element-ui'
	export default {
		name: 'side-item',
    props: {
      data: {
        type: Array,
        default: () => []
      },
    },

		data() {
			return {
				index:1
			}
		},
		mounted() {

		},
		computed: {
			pageLen(){
				return Math.ceil(this.data.length / 10 )
			},
			style() {
				var a= - 2360
				return 'transition: all 0.5s ease 0s; top: '+ (this.index-1) * a  +'px;'
			}
		},
		methods: {
      toDetail(unique) {
        console.log(unique)
        this.$parent.unique = unique
        this.$parent.querySkuDetails(unique)
      },
      prev() {
				if(this.index!=1){
					this.index--
				}
			},
			next(){
				if(this.index < this.pageLen){
					this.index++
				}
			}
		},

	}
</script>

<style scoped="scoped" lang="less">


</style>
